"use client";

import { c as _c } from "react/compiler-runtime";
import { Separator, SideSheetDescription, SideSheetHeader, SideSheetHeaderTitle, TableScrollContainerContext, VisuallyHidden } from "@opensea/ui-kit";
import { useCallbackRef } from "@opensea/ui-kit/hooks";
import { useTranslations } from "next-intl";
import { NotificationsTable } from "./NotificationsTable";
const separatorClassName = "my-0.5";
export function NotificationsSheet(t0) {
  const $ = _c(21);
  const {
    setUnreadCount
  } = t0;
  const t = useTranslations("NotificationsSheet");
  const [ref, setRef] = useCallbackRef();
  let t1;
  if ($[0] !== t) {
    t1 = t("notifications");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <SideSheetHeader><SideSheetHeaderTitle>{t1}</SideSheetHeaderTitle></SideSheetHeader>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("notificationsPanel");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <VisuallyHidden><SideSheetDescription>{t3}</SideSheetDescription></VisuallyHidden>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator className={separatorClassName} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== setUnreadCount) {
    t6 = <NotificationsTable setUnreadCount={setUnreadCount} />;
    $[9] = setUnreadCount;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== setRef || $[12] !== t6) {
    t7 = <div className="h-full overflow-y-auto" ref={setRef}>{t6}</div>;
    $[11] = setRef;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== ref || $[15] !== t7) {
    t8 = <TableScrollContainerContext.Provider value={ref}>{t7}</TableScrollContainerContext.Provider>;
    $[14] = ref;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t4 || $[19] !== t8) {
    t9 = <>{t2}{t4}{t5}{t8}</>;
    $[17] = t2;
    $[18] = t4;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}